<!-- lazy load quill js editor, quill js loses most of the styles when used with material tab lazy loading fixes that-->

<cmp-lazy-load-container>
  <ng-template #body>
    <app-rich-text-editor
      [formControl]="instructionsControl"
      placeholder="Please add instruction text here."
      [required]="true"></app-rich-text-editor> </ng-template
></cmp-lazy-load-container>
